import axios from "axios";
import { config } from "../config.js";
import jwt_decode from "jwt-decode";
import { forceLogout } from "../middleware/auth/index.js";

let authDispatch = null;

const apiClient = axios.create();

const resetSession = () => {
  forceLogout(authDispatch);
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      resetSession();
    }
    return Promise.reject(error);
  }
);

export const registerAuthDispatch = (dispatch) => {
  authDispatch = dispatch;
};

export const currentApi = (type) => {
  switch (type) {
    case "orbit":
      return config.url.ORBIT;

    case "organization":
      return config.url.ORGANIZATION;

    case "user":
      return config.url.USER;

      case "diagnosis":
          return config.url.USER;
  }
};

// Adds the bearer token to headers, or throws (after resetting the session) if the token is expired or invalid.
const withAuthorization = (headers) => {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");

  if (!token || token.length === 0) return headers;

  let exp;
  try {
    ({ exp } = jwt_decode(token));
  } catch (error) {
    resetSession();
    throw new Error("Session invalid");
  }

  if (exp * 1000 <= Date.now()) {
    resetSession();
    throw new Error("Session expired");
  }

  return { ...headers, Authorization: `Bearer ${token}` };
};

export const request = (path, type, data, method, validateStatus) => {
  let headers;
  try {
    headers = withAuthorization({ "Content-Type": "application/json" });
  } catch (error) {
    return Promise.reject(error);
  }

  // validateStatus only when the caller gives one (TO-1872). Passed as undefined, axios treats every status as
  // success, so a 401 never reached the sign-out interceptor above.
  return apiClient({
    method,
    ...(typeof validateStatus === "function" ? { validateStatus } : {}),
    url: `${currentApi(type)}${path}`,
    headers,
    data,
  });
};

// POSTs a File/Blob as the raw request body (not multipart, not JSON).
export const binaryPostRequest = (path, type, file) => {
  let headers;
  try {
    headers = withAuthorization({ "Content-Type": file?.type || "application/octet-stream" });
  } catch (error) {
    return Promise.reject(error);
  }

  return apiClient({
    method: "POST",
    url: `${currentApi(type)}${path}`,
    headers,
    data: file,
  });
};

// GETs a binary response (e.g. an image) as a Blob.
export const blobRequest = (path, type) => {
  let headers;
  try {
    headers = withAuthorization({});
  } catch (error) {
    return Promise.reject(error);
  }

  return apiClient({
    method: "GET",
    url: `${currentApi(type)}${path}`,
    headers,
    responseType: "blob",
  });
};

export const getRequest = (path, type, data, validateStatus) =>
  request(path, type, data, "GET", validateStatus);
export const postRequest = (path, type, data, validateStatus) =>
  request(path, type, data, "POST", validateStatus);
export const patchRequest = (path, type, data, validateStatus) =>
  request(path, type, data, "PATCH", validateStatus);
export const deleteRequest = (path, type, data, validateStatus) =>
  request(path, type, data, "DELETE", validateStatus);
export const putRequest = (path, type, data, validateStatus) =>
  request(path, type, data, "PUT", validateStatus);
